// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__38i0o","head":"ProcedureTableInfo_head__2ZswI"};